import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const PERSON_ID_STORAGE_KEY = "quotient-person-id"

export type PersonId = string

export const PersonIdStore: Store<PersonId, "local"> = createStore({
  key: PERSON_ID_STORAGE_KEY,
  validator: z.string(),
  storageType: "local",
})
